import React from 'react'

const PaymentManagement = () => {
  return (
    <div>PaymentManagement</div>
  )
}

export default PaymentManagement